import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";

function List(props: ListProps) {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 10,
          search: null,
          active: null,
        }}
        path={`/uniftec/redirects`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.Redirects.items}
        formatPagination={(data) => data.Redirects.paginationInfo}
        title="NOVO REDIRECT"
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`/uniftec/redirects/${value}`} value={value} />
            ),
          },
          {
            Header: "Onde",
            accessor: "urlFrom",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Para",
            accessor: "urlTo",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
